import React from 'react';
import { TrendingUp, BarChart3, GitCompare, Layers, BookOpen, Settings, Route, Radio } from 'lucide-react';
import { AgentType } from '../types';

interface PromptStartersProps {
  agentType?: AgentType;
  onSelect: (prompt: string) => void;
}

const ANALYTICS_STARTERS = [
  {
    icon: BarChart3,
    label: 'Top campaigns',
    prompt: 'Which campaigns have the best ROI this week?',
    color: '#3b82f6',
  },
  {
    icon: TrendingUp,
    label: 'EPC trend',
    prompt: "How has our earnings per click been trending by campaign this past week?",
    color: '#10b981',
  },
  {
    icon: GitCompare,
    label: 'Traffic sources',
    prompt: 'Which traffic sources are bringing in the most money?',
    color: '#8b5cf6',
  },
  {
    icon: Layers,
    label: 'Offers by region',
    prompt: 'What are our best offers broken down by region and device over the last 3 days?',
    color: '#f59e0b',
  },
] as const;

const PLATFORM_HELP_STARTERS = [
  {
    icon: BookOpen,
    label: 'Create a campaign',
    prompt: 'How do I create a new campaign?',
    color: '#3b82f6',
  },
  {
    icon: Route,
    label: 'Rotations',
    prompt: 'How do rotations work and how do I set them up?',
    color: '#10b981',
  },
  {
    icon: Radio,
    label: 'Traffic sources',
    prompt: 'How do I set up and manage traffic sources?',
    color: '#8b5cf6',
  },
  {
    icon: Settings,
    label: 'Reports & analytics',
    prompt: 'Where can I find my reports and how do I read them?',
    color: '#f59e0b',
  },
] as const;

export function PromptStarters({ agentType, onSelect }: PromptStartersProps) {
  const STARTERS = agentType === 'platform-help' ? PLATFORM_HELP_STARTERS : ANALYTICS_STARTERS;
  return (
    <div className="py-8 px-2 space-y-5" data-testid="chat-prompt-starters">
      <p className="text-center text-sm text-gray-400">
        Try one of these or type your own question
      </p>
      <div className="grid grid-cols-2 gap-2 max-w-md mx-auto">
        {STARTERS.map((s) => (
          <button
            key={s.label}
            type="button"
            onClick={() => onSelect(s.prompt)}
            className="group text-left rounded-lg border border-gray-200 bg-white px-3 py-2.5
                       hover:border-gray-300 hover:shadow-sm transition-all duration-150"
          >
            <div className="flex items-center gap-1.5 mb-1">
              <s.icon className="h-3.5 w-3.5 shrink-0" style={{ color: s.color }} />
              <span className="text-xs font-medium text-gray-700">{s.label}</span>
            </div>
            <p className="text-[11px] leading-snug text-gray-400 group-hover:text-gray-500 line-clamp-2">
              {s.prompt}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
